import type { ApiEvent } from '#/modules/listing/events/api/types/ApiEvent';

export const canDisplayApplyDetails = ({
  applyUrl,
  applyText,
  applyEmail,
}: Pick<ApiEvent, 'applyUrl' | 'applyText' | 'applyEmail'>) =>
  Boolean(applyUrl || applyText || applyEmail);
